import { render, staticRenderFns } from "./UsuariosAdmin.vue?vue&type=template&id=5b7ff773"
import script from "./UsuariosAdmin.vue?vue&type=script&lang=js"
export * from "./UsuariosAdmin.vue?vue&type=script&lang=js"
import style0 from "./UsuariosAdmin.vue?vue&type=style&index=0&id=5b7ff773&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports